import Text from "./Text";

const IconText = ({ iconInfo, textInfo, gap, iconFirst }) => {


  return (
    <div className="flex items-center">
      {
        iconFirst? (
          iconInfo? (<iconInfo.Icon id={iconInfo.id} ref={iconInfo.ref} className={"shrink-0 " + iconInfo.classes} />): null
        ): (textInfo? (<Text
          text={textInfo.text}
          classes={textInfo.classes ? textInfo.classes : ""}
        />): null)
      }
      {
      (iconInfo && textInfo) ? <div className={gap}>&nbsp;</div> : null
      }
      {
        iconFirst? (
          textInfo? (<Text
            text={textInfo.text}
            classes={textInfo.classes ? textInfo.classes : ""}
          />): null
        ): (iconInfo? (<iconInfo.Icon id={iconInfo.id} ref={iconInfo.ref} className={"shrink-0 " + iconInfo.classes} />): null)
      }
    </div>
  );
};

IconText.defaultProps = {
  gap: "pl-1",
};

export default IconText;
